<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-27 15:54:37
 * @LastEditTime : 2019-12-31 16:17:32
 * @LastEditors  : Please set LastEditors
 -->
<template>
    <!--:title="selectScopeData.title ? selectScopeData.title: '选择考核范围'"-->
    <el-dialog
            class="selfModal"
            :title="selectScopeData.title ? selectScopeData.title: '选择考核范围'"
            :close-on-click-modal="false"
            :visible.sync="selectScopeData.state"
            :before-close="handleDialogClose"
            width="1100px"
            :modal="false"
    >
        <div class="selectScope_wrapper" v-loading="selectScopeLoading">
            <div class="tabs_wrapper" style="position:relative;margin-bottom:0px;">
                <div class="searchDiv">
                    <!-- <div class="stateType">
                        <p>用户类型：</p>
                        <p
                                @click="typeClick(item)"
                                v-for="(item, index) in typeData"
                                :class="type === item.id ? 'typeAffirm' : ''"
                        >
                            {{ item.label }}
                        </p>
                    </div>
                    <div class="stateName">
                        <p>用户姓名：</p>
                        <div class="stateList">
                            <p
                                    @click="nameClick(item, index)"
                                    v-for="(item, index) in itemName"
                                    :class="nameIndexValue === index ? 'typeAffirm' : ''"
                            >
                                {{ item }}
                            </p>
                        </div>
                        <div style="position:absolute;right:0;top:0;">
                            <el-input
                                    v-model="userName"
                                    placeholder="关键字"
                                    style="width:150px;margin-right:10px;"
                                    @keyup.enter.native="userSearch"
                            />
                            <el-button
                                    type="primary"
                                    icon="el-icon-search"
                                    circle
                                    @click="userSearch()"
                            ></el-button>
                        </div>
                    </div> -->
                    <div style="">
                        <el-input
                                v-model="userName"
                                placeholder="用户名"
                                style="width:150px;margin-right:10px;"
                                clearable
                                @change="userSearch"
                                @keyup.enter.native="userSearch"
                        />
                        <el-button
                                type="primary"
                                @click="userSearch()"
                        >搜索</el-button>
                    </div>
                </div>
            </div>
            <div
                    class="content_wrapper"
                    :style="{
          height:
            selectScopeData.type !== 'radio'
              ? 'calc(100% - 130px) !important'
              : 'calc(100% - 100px) !important'
        }"
            >
                <div class="content_wrapper_left">
                    <el-input
                            v-model="filterText"
                            size="small"
                            placeholder="输入关键字过滤"
                            suffix-icon="el-icon-search"
                            style="margin-bottom: 10px;"
                    ></el-input>
                    <el-scrollbar style="height:100%">
                        <el-tree
                                highlight-current
                                :key="treeKey"
                                ref="deptTree"
                                id="taskTreeL"
                                :check-strictly="true"
                                :show-checkbox="true"
                                :filter-node-method="filterNode"
                                :default-checked-keys="defaultCheckedArray"
                                node-key="expandId"
                                :data="deptData"
                                :props="defaultStaticProps"
                                :default-expanded-keys="defaultExpandedKeys"
                                @node-click="getNodeId"
                                @check-change="handleCheckChange"
                        >
              <span class="span-ellipsis" slot-scope="{ node }">
                <span :title="node.label">{{ node.label }}</span>
              </span>
                        </el-tree>
                    </el-scrollbar>
                </div>
                <div class="content_wrapper_right">
                    <div class="content_wrapper_right_table">
                        <div class="select_wrapper">
                            <div class="select_wrapper_content">
                                <!-- <el-scrollbar style="height: 80%;"> -->
                                <el-table
                                        border
                                        height="calc(100% - 53px)"
                                        class="table-border"
                                        ref="multipleRoleUserTable"
                                        :data="deptUserData"
                                        tooltip-effect="dark"
                                        stripe
                                        style="width: 100%;height:100%;overflow-y: auto"
                                        @selection-change="selectionChange"
                                        @select="handleSelect"
                                        @select-all="allSelectionChange"
                                >
                                    <el-table-column
                                            v-if="selectScopeData.type !== 'radio'"
                                            type="selection"
                                            width="55"
                                            align="center"
                                            :selectable="checkSelectable"
                                    ></el-table-column>
                                    <el-table-column
                                            type="index"
                                            label="序号"
                                            width="65"
                                            align="center"
                                    ></el-table-column>
                                    <el-table-column
                                            prop="deptName"
                                            label="部门"
                                            align="center"
                                            show-overflow-tooltip
                                    >
                                    </el-table-column>
                                    <el-table-column
                                            prop="username"
                                            label="姓名"
                                            align="center"
                                            show-overflow-tooltip
                                    >
                                    </el-table-column>
                                    <!-- <el-table-column
                                            prop="type"
                                            label="类型"
                                            width="100"
                                            align="center"
                                            show-overflow-tooltip
                                    >
                                        <template slot-scope="scope">
                                            <span v-if=""></span>
                                            {{ dealRoleType(scope.row.type) }}
                                        </template>
                                    </el-table-column> -->
                                    <el-table-column
                                            v-if="selectScopeData.type === 'radio'"
                                            prop="type"
                                            label="操作"
                                            width="150"
                                            align="center"
                                            show-overflow-tooltip
                                    >
                                        <template slot-scope="scope">
                                            <el-button
                                                    size="small "
                                                    @click="sureClick(false, scope.row)"
                                            ><span>选择</span>
                                            </el-button>
                                        </template>
                                    </el-table-column>
                                </el-table>
                                <!-- 分页start -->
                                <!-- v-if="this.selectUser.total > 0"               -->
                                <div style="margin-top: 10px;text-align:right;">
                                    <el-pagination
                                            background
                                            @current-change="UserCurrentChange"
                                            :current-page.sync="selectUser.current"
                                            layout="total,prev, pager, next"
                                            :total="selectUser.total"
                                    >
                                    </el-pagination>
                                </div>
                                <!-- 分页end -->
                                <!-- </el-scrollbar> -->
                            </div>
                        </div>
                    </div>
                    <div class="content_wrapper_right_list">
                        <!-- <p class="head_title">已选用户</p> -->
                        <div class="right_list_content">
                            <el-scrollbar style="height: 100%;">
                                <el-card class="box-card">
                                    <div
                                            v-if="checkedArray.length < 1"
                                            style="text-align:center;color:#666;"
                                    >
                                        暂无数据
                                    </div>
                                    <div
                                            v-if="checkedArray.length > 0"
                                            v-for="(item, index) in checkedArray"
                                            :key="item.id || item.userId"
                                            class="text item list_item"
                                    >
                    <span style="width:100%;">
                      <span class="list_item_name">
                        <span class="span_text">{{ item.name }}</span>
                        <span
                                class="list_item_icon"
                                @click="deleteCheckedArray(item)"
                        ><i class="el-icon-close"></i
                        ></span>
                      </span>
                      <div
                              v-if="
                          Object.keys(item).includes('mans') &&
                            item.mans.length > 0
                        "
                              v-for="(value, key) in item.mans"
                              :key="value.userId"
                              class="text item list_item"
                              style="padding:0"
                      >
                        <span class="list_item_name user_list_item">
                          <span class="span_text">{{ value.username }}</span>
                          <span
                                  class="list_item_icon"
                                  @click="deleteCheckedArray(value)"
                          ><i class="el-icon-close"></i
                          ></span>
                        </span>
                      </div>
                    </span>
                                    </div>
                                </el-card>
                            </el-scrollbar>
                        </div>
                        <div class="clearSelected-btn" @click="clearCheckedArray()">
                            <el-button type="text"
                            ><i class="el-icon-delete" style="color:red;font-size:14px;"></i
                            ></el-button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div slot="footer" v-if="selectScopeData.type !== 'radio'">
            <el-button
                    type="primary"
                    @click="sureClick(false)"
                    :disabled="selectScopeData.disabled"
            >确 认
            </el-button
            >
            <el-button @click="handleDialogClose()">关 闭</el-button>
        </div>
    </el-dialog>
</template>
<script>
    import {mapGetters, mapMutations} from "vuex";
    import treeMenu from "@/components/treeMenu/index.vue";
    import { getListTableUrl } from "@/api/management/user";
    import {getRoleList, getMixQueryUserPage} from "@/api/dispose/myfillout";
    import {dealRoleType, dealRoleTypeData, stringToArray} from "@/util/utils";

    export default {
        name: "selectScope",
        data() {
            return {
                selectScopeLoading: false,
                dealRoleType: dealRoleType,
                dealRoleTypeData: dealRoleTypeData,
                stringToArray: stringToArray,
                userName: "",
                treeKey: Date.parse(new Date()),
                handleClickedId: {
                    data: 0,
                    key: Date.parse(new Date())
                },
                selectUser: {
                    current: 1,
                    pageSize: 10,
                    total: 0
                },
                selectedUserIdArr: [],
                selectedUserListArr: [],
                deptUserData: [],
                chooseAll: false,
                typeData: [{id: 1, label: "教师"}, {id: 2, label: "教职工"}],
                itemName: [
                    "全部",
                    "A",
                    "B",
                    "C",
                    "D",
                    "E",
                    "F",
                    "G",
                    "H",
                    "I",
                    "J",
                    "K",
                    "L",
                    "M",
                    "N",
                    "O",
                    "P",
                    "Q",
                    "R",
                    "S",
                    "T",
                    "U",
                    "V",
                    "W",
                    "X",
                    "Y",
                    "Z"
                ],
                sortData: ["默认排序", "升序", "降序"],
                type: 1,
                nameIndexValue: 0,
                nameIndex: null,
                cardActiveId: "",
                page: {
                    total: 0, // 总页数
                    currentPage: 1, // 当前页数
                    pageSize: 100, // 每页显示多少条
                    sizes: [10, 20, 50, 100]
                },
                defaultProps: {
                    children: "children",
                    label: "label"
                },
                searchRoleName: "",
                systemRoleData: [],
                defaultExpandIds: [],
                selectUserLoading: false,
                //树形结构
                defaultStaticProps: {
                    children: "children",
                    label: "name" || "label"
                },
                defaultExpandedKeys: [],
                defaultCheckedArray: [],
                checkedArray: [],
                checkedDeptArray: [],
                checkedId: "",
                checkedName: "",
                treeKey: Date.parse(new Date()),
                currentData: "",
                filterText: ""
                //树形结构
            };
        },
        props: {
            selectScopeData: {
                type: Object,
                required: true
            }
        },
        components: {treeMenu},
        computed: {
            ...mapGetters(["checkedItemArray", "chooseDept"]),
            deptData() {
                const deptData = JSON.parse(JSON.stringify(this.chooseDept));
                return deptData;
            }
        },
        watch: {
            filterText(val) {
                this.$refs.deptTree.filter(val);
            },
            deptData: {
                handler(newVal, oldVal) {
                    this.$nextTick(() => {
                        this.generateStaticTree(newVal);
                    });
                },
                immediate: true,
                deep: true
            },
            "selectScopeData.state"(val) {
                // this.clearCheckedItem();
                this.defaultExpandedKeys = [];
                if (!val) {
                    this.defaultDeptIdArr = [];
                    this.$refs.deptTree.setCheckedKeys([]);
                } else {

                    this.initPageParams();
                }
            },
            checkedItemArray: {
                handler(newVal, oldVal) {
                    this.$nextTick(() => {
                    });
                },
                immediate: true,
                deep: true
            },
        },
        created() {
            // this.initPageParams();
        },
        methods: {
            ...mapMutations({
                setDefaultChecked: "setDefaultChecked",
                clearCheckedItem: "clearCheckedItem",
                deleteCheckedItem: "deleteCheckedItem"
            }),
            filterDeptTree(source, id) {
                let result = "";
                if (source && source.length > 0) {
                    const filterFun = target => {
                        target.forEach(item => {
                            if (item.id == id && item.children.length < 1) {
                                result = item;
                            }
                            if (item.children && item.children.length > 0) {
                                filterFun(item.children);
                            }
                        });
                    };
                    filterFun(source);
                }
                return result;
            },
            clearCheckedArray() {
                this.$nextTick(() => {
                    this.defaultDeptIdArr = [];
                    this.$refs.deptTree.setCheckedKeys([]);
                });
                this.deptUserData.forEach(value => {
                    this.$refs.multipleRoleUserTable.toggleRowSelection(value, false);
                });
                this.checkedArray = [];
            },
            deleteCheckedArray(data) {
                if (Object.keys(data).includes("mans")) {
                    const {mans} = data;
                    const index = this.checkedArray.findIndex(e => e.id == data.id);
                    const deptIndex = this.checkedDeptArray.findIndex(e => e.id == data.id);
                    index > -1 && this.checkedArray.splice(index, 1);
                    deptIndex > -1 && this.checkedDeptArray.splice(deptIndex, 1);
                    const idArr = this.checkedDeptArray.map(item => {
                        return item.id;
                    });
                    this.$nextTick(() => {
                        this.defaultDeptIdArr = idArr;
                        this.$refs.deptTree.setCheckedKeys(idArr);
                        const userIdArr = mans.map(item => {
                            return item.userId;
                        });
                        this.deptUserData.forEach(item => {
                            if (userIdArr.includes(item.userId)) {
                                this.$nextTick(() => {
                                    this.$refs.multipleRoleUserTable.toggleRowSelection(
                                        item,
                                        false
                                    );
                                });
                            }
                        });
                    });
                } else {
                    this.checkedArray.forEach((item, index) => {

                        if (item.id == data.deptId) {
                            const {mans} = item;
                            const index = mans.findIndex(e => e.userId == data.userId);
                            index > -1 && mans.splice(index, 1);

                            this.deptUserData.forEach(item => {
                                if (item.userId == data.userId) {
                                    this.$nextTick(() => {
                                        this.$refs.multipleRoleUserTable.toggleRowSelection(
                                            item,
                                            false
                                        );
                                    });
                                }
                            });
                        }
                    });
                }
            },
            filterDeptRowById(source, id) {
                let result = "";
                if (source && source.length > 0) {
                    const filterFun = target => {
                        target.forEach(item => {
                            if (item.id == id) {
                                result = item;
                            } else {
                                if (item.children && item.children.length > 0) {
                                    filterFun(item.children);
                                }
                            }
                        });
                    };
                    filterFun(source);
                }
                return result;
            },
            handleCheckChange(data, checked, indeterminate) {
                var index = this.checkedArray.findIndex(e => {
                    return e.id == data.id;
                });
                var deptIndex = this.checkedDeptArray.findIndex(e => e.id == data.id);
                if (checked === true) {
                    this.currentDeptId = data.id;
                    this.currentData = data;
                    if (deptIndex < 0) {
                        this.checkedDeptArray.push(data);
                    }
                    if (this.defaultDeptIdArr[this.defaultDeptIdArr.length - 1] == data.id) {
                        this.getMixQueryUserPageData();
                    }
                    if (!this.defaultDeptIdArr.includes(data.id)) {
                        this.getMixQueryUserPageData();
                    }
                    if (index < 0 && !data.hasChildren) {
                        data.mans = [];
                        this.checkedArray.push(data);
                    }
                    // if (deptIndex < 0) {
                    //   let filterArray = [];
                    //   filterArray.push(data);
                    //   let findParent = targetId => {
                    //     let result = this.filterDeptRowById(this.deptData, targetId);
                    //     if (result) {
                    //       var findIndex = this.checkedDeptArray.findIndex(
                    //         e => e.id == result.id
                    //       );
                    //       if (findIndex < 0) {
                    //         filterArray.push(result);
                    //       }
                    //       if (result.id != 0) {
                    //         findParent(result.parentId);
                    //       }
                    //     }
                    //   };
                    //   var parentIndex = this.checkedDeptArray.findIndex(
                    //     e => e.id == data.parentId
                    //   );
                    //   if (parentIndex < 0) {
                    //     findParent(data.parentId);
                    //   }
                    //   this.checkedDeptArray = this.checkedDeptArray.concat(
                    //     filterArray.reverse()
                    //   );
                    //   this.$nextTick(() => {
                    //     const deptIdArr = this.checkedDeptArray.map(e => {
                    //       return e.id;
                    //     });
                    //     this.$refs.deptTree.setCheckedKeys(deptIdArr);
                    //   });
                    // }
                    // this.$refs.deptTree.setCheckedKeys([data.id]);
                } else {
                    index > -1 && this.checkedArray.splice(index, 1);
                    deptIndex > -1 && this.checkedDeptArray.splice(deptIndex, 1);
                    if (Object.keys(data).includes("mans")) {
                        data.mans = [];
                        this.$nextTick(() => {
                            const userIdArr = [];
                            this.deptUserData.forEach(value => {
                                if (userIdArr.includes(value.userId) && value.deptId == data.id) {
                                    this.$refs.multipleRoleUserTable.toggleRowSelection(
                                        value,
                                        true
                                    );
                                }
                                if (!userIdArr.includes(value.userId) && value.deptId == data.id) {
                                    this.$refs.multipleRoleUserTable.toggleRowSelection(
                                        value,
                                        false
                                    );
                                }
                            });
                        });
                    }
                }
            },
            //过滤树形节点
            filterNode(value, data) {
                if (!value) return true;
                return data.name.indexOf(value) !== -1;
            },
            generateStaticTree(source) {
                if (source && source.length > 0) {
                    const filterFun = target => {
                        target.forEach(item => {
                            let nodeIsLeaf = item.hasChildren ? true : false;
                            item.label = item.name;
                            item.expandId = item.id;
                            item.isLeaf = nodeIsLeaf;
                            item.popoverId = "popover" + item.id;
                            item.popoverVisible = false;
                            if (item.children.length === 0) {
                                item.mans = [];
                            }
                            if (item.children && item.children.length > 0) {
                                filterFun(item.children);
                            }
                        });
                    };
                    filterFun(source);
                } else {
                    return;
                }
            },
            //树形结构部分
            cancelSelected() {
                this.selectedUserListArr = [];
                this.selectedUserIdArr = [];
                this.selectedUserArr = [];
                this.getMixQueryUserPageData();
            },
            initData(data) {
                this.selectedUserIdArr = JSON.parse(JSON.stringify(data.defaultSelected));
                this.selectedUserListArr = JSON.parse(
                    JSON.stringify(data.selectedUserListArr)
                );
                // this.$nextTick(()=>{
                // this.getMixQueryUserPageData();//注释
                // })
            },
            initPageParams() {
                this.selectedUserIdArr = [];
                this.selectedUserListArr = [];
                this.type = this.typeData[0].id;
                this.nameIndexValue = 0;
                this.nameIndex = null;
                this.cardActiveId = "";
                this.selectUser.current = 1;
                this.treeKey = Date.parse(new Date());
                this.clearCheckedArray();
                this.$nextTick(() => {
                    this.deptData.forEach((item, index) => {
                        if (
                            item.level == 1 &&
                            !this.defaultExpandedKeys.includes(item.expandId)
                        ) {
                            this.defaultExpandedKeys.push(item.expandId);
                        }
                    });
                    setTimeout(() => {
                        this.defaultDeptIdArr = this.selectScopeData.depts;
                        this.$refs.deptTree.setCheckedKeys(this.selectScopeData.depts);
                        if (this.selectScopeData.mans.length > 0) {
                            this.checkedArray = this.selectScopeData.mans;
                        }
                        if (this.selectScopeData.depts.length > 0) {
                            let deptArray = [];
                            this.selectScopeData.depts.forEach((item, index) => {
                                // let result = this.filterDeptTree(this.deptData, item);
                                let result = this.filterDeptRowById(this.deptData, item);
                                if (result) {
                                    deptArray.push(result);
                                }
                            });
                            this.checkedDeptArray = deptArray;
                            const length = this.selectScopeData.depts.length;
                            this.$refs["deptTree"].setCurrentKey(
                                this.selectScopeData.depts.sort(this.compare)[length - 1]
                            );
                            this.getNodeId(this.selectScopeData.depts[length - 1]);
                            // this.getMixQueryUserPageData();//注释
                        } else {
                            this.$refs["deptTree"].setCurrentKey(1);
                            this.getNodeId(1);
                        }
                    });
                });
            },
            // 数组排序
            compare(x, y) {
                if (x < y) {
                    return -1;
                } else if (x > y) {
                    return 1;
                } else {
                    return 0;
                }
            },
            userSearch() {
                this.selectUser.current = 1;
                this.getMixQueryUserPageData();
            },
            clearUserName() {
                this.userName = "";
                this.getMixQueryUserPageData();
            },
            UserCurrentChange(val) {
                this.selectUser.current = val;
                this.getMixQueryUserPageData();
            },
            selectionChange(val) {
                this.chooseAll && (this.chooseAll = false);
            },
            allSelectionChange(selection) {
                if (selection.length > 0) {
                    const deptIdArr = this.checkedArray.map(e => {
                        return e.id;
                    });
                    if (!deptIdArr.includes(selection[0].deptId)) {
                        deptIdArr.push(selection[0].deptId);
                        var deptIndex = this.checkedDeptArray.findIndex(e => e.id == selection[0].deptId);
                        if (deptIndex < 0) {
                            let filterArray = [];
                            let data = this.filterDeptRowById(this.deptData, selection[0].deptId);
                            filterArray.push(data);
                            let findParent = targetId => {
                                let result = this.filterDeptRowById(this.deptData, targetId);
                                if (result) {
                                    var findIndex = this.checkedDeptArray.findIndex(
                                        e => e.id == result.id
                                    );
                                    if (findIndex < 0) {
                                        filterArray.push(result);
                                    }
                                    if (result.id != 0) {
                                        findParent(result.parentId);
                                    }
                                }
                            };
                            var parentIndex = this.checkedDeptArray.findIndex(
                                e => e.id == data.parentId
                            );
                            if (parentIndex < 0) {
                                findParent(data.parentId);
                            }
                            this.checkedDeptArray = this.checkedDeptArray.concat(
                                filterArray.reverse()
                            );
                            this.$nextTick(() => {
                                // const deptIdArr = this.checkedDeptArray.map(e => {
                                this.defaultDeptIdArr = this.checkedDeptArray.map(e => {
                                    return e.id;
                                });
                                this.$refs.deptTree.setCheckedKeys(this.defaultDeptIdArr);
                            });
                        }
                        // this.defaultDeptIdArr=deptIdArr;
                        // this.$refs.deptTree.setCheckedKeys(deptIdArr);
                        setTimeout(() => {
                            this.deptUserData.forEach(item => {
                                this.$nextTick(() => {
                                    this.$refs.multipleRoleUserTable.toggleRowSelection(item, true);
                                    this.checkedArray.forEach((value, key) => {
                                        if (
                                            value.id == selection[0].deptId &&
                                            !value.mans.includes(item)
                                        ) {
                                            value.mans.push(item);
                                        }
                                    });
                                });
                            });
                        }, 100);
                    }
                    this.checkedArray.forEach((item, index) => {
                        if (Object.keys(item).includes("mans")) {
                            if (item.id == selection[0].deptId) {
                                const userIdArr = item.mans.map(e => {
                                    return e.userId;
                                });
                                selection.forEach((value, key) => {
                                    if (!userIdArr.includes(value.userId)) {
                                        item.mans.push(value);
                                    }
                                });
                            }
                        }
                    });
                } else {
                    this.checkedArray.forEach((item, index) => {
                        if (Object.keys(item).includes("mans")) {
                            if (item.id == this.deptUserData[0].deptId) {
                                this.deptUserData.forEach((value, key) => {
                                    const index = item.mans.findIndex(e => {
                                        return e.userId == value.userId;
                                    });
                                    index > -1 && item.mans.splice(index, 1);
                                });
                            }
                        }
                    });
                }
            },
            handleSelect(selection, row) {
                this.multipleDeptUser = selection;
                this.chooseAll = false;
                const deptIdArr = this.checkedArray.map(e => {
                    return e.id;
                });
                if (!deptIdArr.includes(row.deptId) && selection.includes(row)) {
                    deptIdArr.push(row.deptId);
                    // this.$refs.deptTree.setCheckedKeys(deptIdArr.reverse());
                    var deptIndex = this.checkedDeptArray.findIndex(e => e.id == row.deptId);
                    if (deptIndex < 0) {
                        let filterArray = [];
                        let data = this.filterDeptRowById(this.deptData, row.deptId);
                        filterArray.push(data);
                        let findParent = targetId => {
                            let result = this.filterDeptRowById(this.deptData, targetId);
                            if (result) {
                                var findIndex = this.checkedDeptArray.findIndex(
                                    e => e.id == result.id
                                );
                                if (findIndex < 0) {
                                    filterArray.push(result);
                                }
                                if (result.id != 0) {
                                    findParent(result.parentId);
                                }
                            }
                        };
                        var parentIndex = this.checkedDeptArray.findIndex(
                            e => e.id == data.parentId
                        );
                        if (parentIndex < 0) {
                            findParent(data.parentId);
                        }
                        this.checkedDeptArray = this.checkedDeptArray.concat(
                            filterArray.reverse()
                        );
                        this.$nextTick(() => {
                            // const deptIdArr = this.checkedDeptArray.map(e => {
                            this.defaultDeptIdArr = this.checkedDeptArray.map(e => {
                                return e.id;
                            });
                            this.$refs.deptTree.setCheckedKeys(this.defaultDeptIdArr);
                        });
                    }
                    // this.$refs.deptTree.setCheckedKeys(deptIdArr);
                    setTimeout(() => {
                        this.deptUserData.forEach(item => {
                            if (item.userId == row.userId) {
                                this.$nextTick(() => {
                                    this.$refs.multipleRoleUserTable.toggleRowSelection(item, true);
                                    this.checkedArray.forEach((item, index) => {
                                        if (item.id == row.deptId && !item.mans.includes(row)) {
                                            item.mans.push(row);
                                        }
                                    });
                                });
                            }
                        });
                    }, 100);
                }
                this.checkedArray.forEach((item, index) => {
                    if (Object.keys(item).includes("mans")) {
                        if (item.id == row.deptId) {
                            // item.mans = selection;
                            if (!selection.includes(row)) {
                                const index = item.mans.findIndex(e => {
                                    return e.userId == row.userId;
                                });
                                item.mans.splice(index, 1);
                            } else {
                                if (!item.mans.includes(row)) {
                                    item.mans.push(row);
                                }
                            }
                        }
                    }
                });
                this.$forceUpdate()
                console.log(this.checkedArray)
            },
            handleClick(tab, event) {
                this.type = this.typeData[0].id;
                this.nameIndexValue = 0;
                this.nameIndex = null;
                this.selectUser.current = 1;
            },
            getNodeId(data) {
                if (Object.prototype.toString.call(data) === "[object Object]") {
                    this.currentDeptId = data.id;
                } else {
                    this.currentDeptId = data;
                }
                this.selectUser.current = 1;
                this.getMixQueryUserPageData();
            },
            // 设置表格行不可选
            checkSelectable(row, index) {
                if (row.isCanChecked) {
                    return true;
                }
                return false;
            },
            getMixQueryUserPageData() {
                let params = {
                    userName: this.userName,
                    // queryType: 0,
                    current: this.selectUser.current,
                    size: this.selectUser.pageSize,
                    // userType: this.type,
                    // nameIndex: this.nameIndex == "全部" ? "" : this.nameIndex
                };
                // if (this.currentData) {
                //   params.deptId = this.currentData.id;
                // }
                if (this.currentDeptId) {
                    params.deptId = this.currentDeptId;
                }
                this.selectUserLoading = true;
                getListTableUrl(params).then(res => {
                    if (res.data.code == 0) {
                        this.selectUserLoading = false;
                        const records = res.data.data.records;
                        this.$nextTick(() => {
                            // this.currentData=this.filterDeptTree(this.deptData,params.deptId);
                            this.currentData = this.filterDeptRowById(
                                this.deptData,
                                params.deptId
                            );
                            if (records.length > 0 && this.currentData) {
                                if (!this.currentData.hasChildren) {
                                    records.forEach(item => {
                                        item.isCanChecked = true;
                                    });
                                } else {
                                    records.forEach(item => {
                                        item.isCanChecked = false;
                                    });
                                }
                            }
                        });
                        this.deptUserData = records;
                        this.$nextTick(() => {
                            this.checkedArray.forEach((item, index) => {
                                if (Object.keys(item).includes("mans")) {
                                    if (records.length > 0 && item.id == records[0].deptId) {
                                        const userIdArr = item.mans.map(e => {
                                            return e.userId;
                                        });
                                        this.deptUserData.forEach(value => {
                                            if (userIdArr.includes(value.userId)) {
                                                this.$refs.multipleRoleUserTable.toggleRowSelection(
                                                    value,
                                                    true
                                                );
                                            } else {
                                                this.$refs.multipleRoleUserTable.toggleRowSelection(
                                                    value,
                                                    false
                                                );
                                            }
                                        });
                                    }
                                }
                            });
                        });
                        this.selectUser.total = res.data.data.total;
                    }
                });
            },
            typeClick(item) {
                this.type = item.id;
                this.selectUser.current = 1;
                this.getMixQueryUserPageData();
            },
            nameClick(item, int) {
                this.nameIndexValue = int;
                this.nameIndex = item;
                this.selectUser.current = 1;
                this.getMixQueryUserPageData();
            },
            filterFun(source) {
                source.filter((child, index) => {
                    if (child.expanded) {
                        child.expanded = false;
                    }
                    if (child.childNodes && child.childNodes.length > 0) {
                        this.filterFun(child.childNodes);
                    }
                });
            },
            handleNodeClick(data) {
                if (data.level === 1) {
                    this.personType = data.id - 1;
                    this.selectedPersonId = "";
                    this.cardActiveId = "";
                } else {
                    this.personType = data.parentId - 1;
                    this.selectedPersonId = data.id;
                    this.cardActiveId = data.id;
                }
                this.getMixQueryUserPageData();
            },
            // 删除被选中的用户
            delSelectedUser(row) {
                const selectIndex = this.selectedUserListArr.findIndex(e => e === row);
                this.selectedUserIdArr.splice(selectIndex, 1);
                this.selectedUserListArr.splice(selectIndex, 1);
                const rowId = row.directorId || row.userId;
                this.deptUserData.forEach(item => {
                    if (item.userId == rowId) {
                        this.$refs.multipleRoleUserTable.toggleRowSelection(item, false);
                    }
                });
            },
            // 关闭用户选择
            handleDialogClose() {
                // this.$emit("closeSelectScope");
                this.selectScopeData.state = false;
            },
            sureClick(flag, data) {
                const mans = JSON.parse(JSON.stringify(this.checkedArray));
                const depts = JSON.parse(JSON.stringify(this.checkedDeptArray));
                this.$emit("closeSelectScope", {
                    depts,
                    mans
                });
            }
        }
    };
</script>
<style lang="less">
    @import url("selectScope.less");
</style>